import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import styled from "styled-components";
import { useThemeMode } from "../../colors";
import { GradientText } from "../dashboard/Gradient";

const DescriptionContainer = styled(Box)`
  padding: 80px 24px 0px 24px;
  text-align: center;
  background: ${props => props.theme.palette.background.default};
  margin-top: 64px;
`;

const ContentWrapper = styled(Box)`
  max-width: 800px;
  margin: 0 auto;
`;

const MainText = styled(Typography)`
  color: ${props => props.theme.palette.text.primary};
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 64px;
`;

export const Description: React.FC = () => {
  const theme = useTheme();
  const { colors } = useThemeMode();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <DescriptionContainer>
      <ContentWrapper>
        <Typography variant="h2" mb="36px" color={theme.palette.mode === "dark" ? colors.text.brand.darkest : colors.text.neutral.dark}>
          A Map for <GradientText variant="h2" display="inline" sx={{ textDecoration: "none !important"}}>Any</GradientText> Occasion
        </Typography>
        <MainText
          variant={isMobile ? "h5" : "h4"}
          sx={{ 
            fontSize: isMobile ? '16px !important' : '20px !important',
            fontWeight: 300,
            marginBottom: "32px",
            fontFamily: "Poppins",
          }}
        >
          Bespoke, personalized maps that celebrate life's
          special moments - perfect for gifting, home decor, or
          keepsakes
        </MainText>
      </ContentWrapper>
    </DescriptionContainer>
  );
};
